export default {
  state: {
    isLoading: false,
    navigationOpen: false,
    smallNavigation: false
  },
  mutations: {
    shrinkNavigation(state) {
      state.smallNavigation = true
    },
    expandNavigation(state) {
      state.smallNavigation = false
    },
    startLoading(state) {
      state.isLoading = true
    },
    stopLoading(state) {
      state.isLoading = false
    },
    openNavigation(state) {
      state.navigationOpen = true
    },
    closeNavigation(state) {
      state.navigationOpen = false
    },
  }
}